var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuizdark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6186 20.5051H18.1269C18.6174 20.5051 19.0241 20.0943 19.0241 19.5989C19.0241 19.1034 18.6174 18.7047 18.1269 18.7047H11.6186C11.1281 18.7047 10.7213 19.1034 10.7213 19.5989C10.7213 20.0943 11.1281 20.5051 11.6186 20.5051ZM15.6623 12.663H11.6186C11.1281 12.663 10.7213 13.0739 10.7213 13.5693C10.7213 14.0647 11.1281 14.4634 11.6186 14.4634H15.6623C16.1528 14.4634 16.5596 14.0647 16.5596 13.5693C16.5596 13.0739 16.1528 12.663 15.6623 12.663ZM24.2002 11.6065C24.4814 11.6032 24.7876 11.5997 25.0658 11.5997C25.3649 11.5997 25.6042 11.8414 25.6042 12.1434V21.8584C25.6042 24.8551 23.1995 27.2839 20.2325 27.2839H10.7094C7.5988 27.2839 5.0625 24.7343 5.0625 21.5926V8.56677C5.0625 5.5701 7.47917 3.11719 10.4581 3.11719H16.8467C17.1578 3.11719 17.3971 3.37094 17.3971 3.67302V7.56385C17.3971 9.7751 19.2036 11.5876 21.3929 11.5997C21.9043 11.5997 22.3552 11.6035 22.7497 11.6069C23.0567 11.6095 23.3295 11.6118 23.5703 11.6118C23.7406 11.6118 23.9614 11.6092 24.2002 11.6065ZM24.5301 9.84277C23.5466 9.8464 22.3874 9.84277 21.5535 9.83431C20.2303 9.83431 19.1404 8.73352 19.1404 7.3971V4.21194C19.1404 3.69115 19.7661 3.43256 20.1238 3.80835C20.7714 4.48844 21.6614 5.42334 22.5473 6.35391C23.4305 7.28173 24.3097 8.20525 24.9404 8.86765C25.2898 9.23377 25.0337 9.84156 24.5301 9.84277Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizdark);
export default __webpack_public_path__ + "static/media/quizdark.7c991a6a87659e6b9b7b55969b1cdcd4.svg";
export { ForwardRef as ReactComponent };